// ABOUTME: The collection-level license banner (DVLP-7860, requirement 6).
// ABOUTME: Shown only when nothing the buyer holds covers this collection and something is for sale.
import { observer } from 'mobx-react';
import {
  Button,
  CloseIcon,
  IconButton,
  Typography,
  emptyFragment,
} from '@execonline-inc/execonline-ui';
import { T } from '../../../../../Translations';
import { useTranslationsContext } from '../../../../../Translations/UseTranslationsContext';
import licensePurchaseStore from '../Store';
import { ShelfPrice } from './Common';

/** The floor, never one price: with offers at different prices, one would be wrong for the others. */
const LowestPrice = observer(function LowestPrice() {
  const cheapest = Math.min(...licensePurchaseStore.offers.map((offer) => offer.priceInCents));
  return (
    <Typography as="span" variant="bodyMedium" fontWeight="bold" color="dark">
      <ShelfPrice cents={cheapest} />
    </Typography>
  );
});

function LicenseOfferPrompt() {
  const { translate } = useTranslationsContext();

  if (!licensePurchaseStore.showsPrompt) {
    return emptyFragment();
  }

  return (
    <section
      data-intercom-target="license-offer-prompt"
      aria-labelledby="license-offer-prompt-heading"
      className="mx-auto box-border w-full px-6 xl:container md:px-16 [&_button]:font-sans"
    >
      <div className="flex flex-col gap-4 border border-l-4 border-gray-300 border-l-teal-600 bg-white px-5 py-4 shadow-[0_0_4px_0_#0000001a] md:flex-row md:items-center md:justify-between">
        <div className="min-w-0">
          <Typography
            id="license-offer-prompt-heading"
            as="h2"
            variant="subtitleMedium"
            fontWeight="semibold"
            className="tracking-normal text-black"
          >
            <T kind="Choose the license that fits your development goals" />
          </Typography>
          <Typography as="p" variant="bodyMedium" color="dark-gray" className="mt-1">
            <T
              kind="Get a year of access to courses from the world’s top business schools, from <price/>."
              price={<LowestPrice />}
            />
          </Typography>
        </div>
        <div className="flex flex-none items-center gap-4">
          <Button
            color="primary"
            size="md"
            onClick={licensePurchaseStore.openFromCollection}
            data-intercom-target="license-offer-prompt-button"
          >
            <T kind="See license options" />
          </Button>
          <IconButton
            data-intercom-target="license-offer-prompt-dismiss-button"
            aria-label={translate('Dismiss')}
            onClick={licensePurchaseStore.dismissPrompt}
          >
            <CloseIcon color="gray" size="md" />
          </IconButton>
        </div>
      </div>
    </section>
  );
}

export default observer(LicenseOfferPrompt);
